<template>
    <el-dialog v-model="dialogShow" width="400px" title="VIP与AI次数购买" append-to-body center @close="closeEvent" modal-class="dialog-new-model">
        <div class="login-container">
            <div class="vip-tab">
                <el-radio-group v-model="purchaseType" fill="#ef8b25" @change="initIndex=0">
                    <el-radio-button label="VIP续期" value="vip" />
                    <el-radio-button label="AI次数购买" value="ai" />
                </el-radio-group>
            </div>
            <div style="margin:10px 0;">
                <el-carousel :autoplay="false" type="card" height="180px" @change="cardChange" :pause-on-hover="false">
                    <el-carousel-item v-for="item in payType[purchaseType]" :key="item.memberId">
                        <div v-if="purchaseType=='vip'" class="vip-card">
                            <div class="title1">{{ item.memberName }}</div>
                            <div class="title2">￥{{ item.discountPrice }}</div>
                            <div class="title3">￥{{ item.originalPrice }}</div>
                            <div class="activeColor">购买送{{item.memberAiTimes}}次AI调用次数</div>
                            <div class="vip-card-top" v-if="item.isFirst">首月特惠</div>
                        </div>
                        <div v-if="purchaseType=='ai'" class="vip-card">
                            <div class="title1">{{ item.memberAiTimes }}次</div>
                            <div class="title2">￥{{ item.discountPrice }}</div>
                            <div class="title3">￥{{ item.originalPrice }}</div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="vip-payway">
                <div class="vip-payway-title">支付方式：</div>
                <el-radio-group v-model="payWay" class="vip-payway-radio">
                    <el-radio value="wechat" size="large" border>
                        <img style="width:20px;height:20px;margin-right:5px;" src="@/assets/img/wechat.png" /> 微信支付
                    </el-radio>
                    <el-radio value="alipay" size="large" border>
                        <img style="width:20px;height:20px;margin-right:5px;" src="@/assets/img/alipay.png" /> 支付宝支付
                    </el-radio>
                </el-radio-group>
            </div>
            <div>
                <el-button style="width:100%" color="#ef8b25" class="footer-btn1" @click="confirmEvent">确认支付</el-button>
            </div>

            <div style="margin-top:10px;text-align:center;">

                <el-button link plain @click="historyShow=true">
                    查看明细记录
                </el-button>
            </div>
        </div>
    </el-dialog>

    <el-dialog v-model="alipayShow" fullscreen @close="alipayClose">
        <iframe v-if="alipayShow" :srcdoc="alipayHtml" frameborder="no" border="no" marginwidth="0" marginheight="0" scrolling="0" width="100%" height="700px" style="overflow:hidden"></iframe>
    </el-dialog>

    <el-dialog title="扫一扫，微信支付" v-model="wechatShow" fullscreen @close="wechatClose" append-to-body>
        <div id="qrcode" style="width: 350px; height: 350px; margin: auto"></div>
        <div style="text-align:center;">
            <el-button color="#ef8b25 " class="footer-btn1 " @click="wxpaySuccess">支付成功</el-button>
        </div>
    </el-dialog>

    <purchase-history-dialog :popupShow="historyShow" v-if="historyShow" @close="historyShow=false"></purchase-history-dialog>
</template>
<script lang="ts" setup>
import purchaseHistoryDialog from "./purchaseHistoryDialog.vue"
import { ref, reactive, onMounted, defineProps, defineEmits, nextTick } from 'vue';
import { getVipType, toZhiFuBaoPay, toWexinPay } from "@/api/common.js"
import QRCode from "qrcode";
import { ElMessage } from 'element-plus'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
const router = useRouter();
const store = useStore();
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    },
    type: {
        type: String,
        default: 'vip'
    }
})
const dialogShow = ref(props.popupShow)
const purchaseType = ref('vip')
const payWay = ref('wechat')
const payType = ref({})
let initIndex = ref(0)
const alipayHtml = ref()
const alipayShow = ref(false)
const historyShow = ref(false)
const wechatShow = ref(false)
const wechatUrl = ref()
const emitList = defineEmits(['close', 'wxpaySuccess'])


function closeEvent() {
    emitList('close')
}

function getTypeList() {
    getVipType({}).then(res => {
        let typeList = (res.data || []).filter(item => {
            return item.memberCardType != 4
        });
        let timeList = (res.data || []).filter(item => {
            return item.memberCardType == 4
        });
        payType.value.vip = typeList
        payType.value.ai = timeList
    })
}

function cardChange(val) {
    initIndex.value = val;
    console.log(initIndex.value)
}

function confirmEvent() {
    const vipList = payType.value[purchaseType.value]
    console.log(vipList)
    const memberId = vipList[initIndex.value].memberId
    console.log(memberId, payWay.value)
    if (payWay.value == 'alipay') {
        toZhiFuBaoPay(memberId).then(res => {
            alipayHtml.value = res.data
            alipayShow.value = true
        })
    } else if (payWay.value == 'wechat') {
        toWexinPay(memberId).then(res => {
            wechatShow.value = true
            QRCode.toCanvas(res.data.codeUrl, {
                width: 350,
                height: 350,
            }).then((rescode) => {
                nextTick(() => {
                    const box = document.getElementById("qrcode");
                    box.innerHTML = '';
                    box.appendChild(rescode);
                });
            });
        })
    }
}

function wechatClose() {
    wechatShow.value = false
    wechatUrl.value = ''
}

function wxpaySuccess() {
    wechatShow.value = false
    wechatUrl.value = ''
    emitList('wxpaySuccess')
}

function alipayClose() {
    alipayShow.value = false
    alipayHtml.value = ''

}

onMounted(() => {
    purchaseType.value = props.type
    getTypeList()
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.login-container {
    padding: 10px;
    .login-title {
        font-size: 20px;
        font-weight: bold;
        color: $base-text-color;
        margin-bottom: 10px;
    }
    .login-tabs {
        display: flex;
        font-weight: bold;
        color: $base-text-color;
        &>div {
            width: 100px;
            text-align: center;
            line-height: 24px;
        }
        .active {
            color: $base-color;
            border-bottom: 2px solid $base-color;
        }
    }
    .login-form {
        margin: 20px 0 0;
    }

    .vip-card {
        height: 100%;
        border-radius: 10px;
        text-align: center;
        font-size: 12px;
        position: relative;
        .vip-card-top {
            position: absolute;
            top: -22px;
            right: 0;
            background: #ef8b25;
            color: #fff;
            width: 60px;
            height: 20px;
            line-height: 20px;
            border-radius: 10px;
            font-size: 10px;
            transform: translate(-58px, 0);
        }
        .title1 {
            margin-top: 30px;
            font-size: 14px;
            font-weight: bold;
        }
        .title2 {
            font-weight: 600;
            font-size: 26px;
            color: #ef8b25;
            margin: 10px 0;
        }
        .title3 {
            -webkit-text-decoration-line: line-through;
            text-decoration-line: line-through;
            color: #909399;
            font-size: 12px;
            margin: 10px 0;
        }
    }

    .vip-payway {
        margin: 10px 0;
        .vip-payway-title {
            line-height: 24px;
            font-weight: bold;
        }
    }

    .el-carousel__item.is-active {
        background-color: #fff0e3;
        border: 1px solid #ee8d27;
        .title2 {
            font-size: 28px;
        }
    }

    .el-carousel__item {
        background-color: #e9eff1;
        border: 1px solid #cbcbcb;
        border-radius: 10px;
        box-sizing: border-box;
    }
}
</style>


<style lang="scss">
@import "@/style/variable.scss";
.dialog-new-model {
    .el-dialog {
        background: url("@/assets/img/bg2.jpg") no-repeat;
        background-size: 100% 100%;
        .el-divider__text {
            background-color: transparent;
        }
    }
    .vip-payway-radio {
        .el-radio__label {
            display: flex;
        }
    }

    .el-carousel__button {
        width: 10px !important;
        height: 10px !important;
        border-radius: 50% !important;
    }
}
</style>